module.exports = __webpack_public_path__ + "images/help/video-preview-ical-1397b768aef00fa0d504cff04ad89dcc.jpg";